import React from 'react';
import { Bar } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";

const ProposteRankingTableSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    return (drawable &&
        <Box className="report-itemgroup">
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Bar
                        title={t("Proposal by Area")}
                        dataProviderName={'statisticsviews/proposalperarea/aggregated/views_opportunities_proposal/_related_area_name'}
                        filters={filterModel}
                        direction={'horizontal'}
                    />
                </Box>
                <Box className="report-item">
                    <Bar
                        title={t("Proposal by Shop")}
                        dataProviderName={"statisticsviews/proposalpershop/aggregated/views_opportunities_proposal/_related_shop_name"}
                        filters={filterModel}
                        direction={'horizontal'}
                    />
                </Box>
                {/* <Box className="report-item">
                    <Bar
                        title={t("Proposal by Agent")}
                        dataProviderName={"statisticsviews/proposalperagent/aggregated/views_opportunities_proposal/_related_agent_fullname"}
                        filters={filterModel}
                        direction={'horizontal'}
                    />
                </Box> */}

                <Box className="report-item">
                    <Bar
                        title={t("Proposal by Source")}
                        dataProviderName={"statisticsviews/proposalpersource/aggregated/views_opportunities_proposal/_related_source_name"}
                        filters={filterModel}
                        direction={'horizontal'}
                    />
                </Box>
            </Box>
            
        </Box>
    )
}

export default ProposteRankingTableSet;
